// extracted by mini-css-extract-plugin
export var link = "_f-0";